/**
 * @generated SignedSource<<f53a34ab758b48abc9c97dfc7a9527b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewOralInterview_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualSummary",
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
};

node.hash = "1746b1e51ec235bdcd1a604ebb72d148";

module.exports = node;
